__turbopack_context__.v({
  "actions": "index-module-scss-module__Bdro3q__actions",
  "brand": "index-module-scss-module__Bdro3q__brand",
  "brandName": "index-module-scss-module__Bdro3q__brandName",
  "closeButton": "index-module-scss-module__Bdro3q__closeButton",
  "drawer": "index-module-scss-module__Bdro3q__drawer",
  "entryButton": "index-module-scss-module__Bdro3q__entryButton",
  "entryButtonCollapsed": "index-module-scss-module__Bdro3q__entryButtonCollapsed",
  "entryButtonText": "index-module-scss-module__Bdro3q__entryButtonText",
  "entryIcon": "index-module-scss-module__Bdro3q__entryIcon",
  "fixedEntry": "index-module-scss-module__Bdro3q__fixedEntry",
  "header": "index-module-scss-module__Bdro3q__header",
  "iconAction": "index-module-scss-module__Bdro3q__iconAction",
  "iframe": "index-module-scss-module__Bdro3q__iframe",
  "mobileDrawer": "index-module-scss-module__Bdro3q__mobileDrawer",
});
